// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jiIt","toggleWrap":"styles_toggleWrap__2BqFB","content":"styles_content__J7uIV","selectAreaCode":"styles_selectAreaCode__22M4x"};